import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="hero">
        <h1>TJ’s Photo Phactory</h1>
        <p>Capturing Life’s Best Moments – Coming Soon</p>
      </div>
    </div>
  );
}

export default App;